import React from "react";
import "./styles.css";

const GroupApprovers = ({ description }) => {
    return (
        <div className="userTag approver">
            <p>{description ? description : "APPROVER"}</p>
        </div>
    );
};

export default GroupApprovers;